import { BaseActionsProps, BaseState } from "@/store/modules/helpers/baseState";

/**
 * Samling av registrerade moduler och dess timeout id
 */
const moduleTimeoutIds: {
    [key: string]: null | number;
} = {};

const delayedResetTime = 1000 * 60; // 1 minuter

/**
 * Resetta timeout för reset av state
 */
export const resetDelayedResetTimeout = ({ moduleName }: { moduleName: string }) => {
    const delayedResetTimeoutId = moduleTimeoutIds[moduleName];

    if (delayedResetTimeoutId) {
        clearTimeout(delayedResetTimeoutId);
        moduleTimeoutIds[moduleName] = null;
    }
};

/**
 * Starta en timer för reset av state. Målet är att behålla cache ett tag utifall användaren går in på en komponent
 * som använder sig av data i modulen igen
 */
export const delayedReset = ({
    commit,
    moduleName,
}: {
    moduleName: string;
    commit: BaseActionsProps<BaseState>["commit"];
}) => {
    resetDelayedResetTimeout({ moduleName });

    if (typeof moduleTimeoutIds[moduleName] !== "number" && moduleTimeoutIds[moduleName] !== null) {
        moduleTimeoutIds[moduleName] = null;
    }

    moduleTimeoutIds[moduleName] = setTimeout(() => {
        commit("reset");
    }, delayedResetTime) as unknown as number;
};
